<template>
  <div id="content">
    <div class="inner">
      <p class="paging" v-if="showLink">
        <router-link :to="{ name: 'reports' }" class="btn btn_back" v-translate>Seznam</router-link>
      </p>
      <h1>{{ operatorName }}</h1>
    </div>
    <div class="inner_white">
      <ReportsOperatorListFilter
          :filterData="filterData"
          :channelPackagesCounts="channelPackages"
          ref="reportsoperatorlistfilterref"
          @onChange="onFilterChange"
      />
      <div class="scroll-wrapper">
        <div class="table_overflow" id="contentBox" data-table-id="reports-operators">
          <table class="vypis" ref="table_with_action_line">
            <thead>
            <tr v-if="entities.length > 0">
              <th class="no_padding drag_drop"></th>
              <th class="no_padding checkbox"></th>
              <sorting-table-title
                  v-for="title in sortingTableTitles"
                  :key="title.key"
                  :column="title.column"
                  :sort="getActiveSort(title.column)"
                  @changeSorting="changeSorting"
              >{{ title.name }}
              </sorting-table-title>
              <th class="no_padding"></th>
            </tr>
            </thead>
            <reports-operator-row v-for="entity in entities"
                                  :item="entity"
                                  :key="entity.id"
                                  :packageNames="filterData.operator_data.channel_packages"
                                  :selected-items="selectedEntities"
                                  @input="select"
            ></reports-operator-row>
            <tr v-if="entities.length === 0">
                 <td colspan="8">{{ $gettext('Nebyly nalezeny žádné reporty.') }}</td>
            </tr>
          </table>
        </div>
      </div>
      <list-action-line
          :entities="entities"
          :selected-entities="selectedEntities"
          :multiple-action-options="multipleActionOptions"
          :offset="formFields.offset"
          :limit="formFields.limit"
          :total-count="totalCount"
          table-id="reports-operators"
          @select-all="toggleSelectAll"
          @run-multiple-action="runMultipleAction"
          @limit="setLimit"
          @offset="setOffset"
          ref="action_line"
      ></list-action-line>
    </div>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions";
import ReportsOperatorRow from "./ReportsOperatorRow";
import ReportsOperatorListFilter from "./ReportsOperatorListFilter";
import {downloadTableFile} from "@/utils/helpers"

export default {
  name: "OperatorReports",
  components: {ReportsOperatorRow, ReportsOperatorListFilter},
  mixins: [listActions],
  data() {
    return {
      entities: [],
      channelPackages: {},
      moduleName: 'reportsOperator',
      formFields: {
        id_operator: null,
        id_report: null,
        limit: 50,
        sort: {
          column: 'rs.name',
          direction: 'asc'
        },
      },
      filterData: {},
      sortingTableTitles: [
        {key: 1, name: this.$gettext('Název odběratele'), column: 'rs.name'},
        {key: 2, name: this.$gettext('Balíčky'), column: 'channel_package_count'},
        {key: 3, name: this.$gettext('Počet simultánně streamujících zařízení nad limit'), column: 'rs.paidDeviceCount'},
        {key: 4, name: this.$gettext('Počet firstscreen zařízení nad limit'), column: 'rs.firstscreenDeviceAboveLimitCount'},
        {key: 5, name: this.$gettext('Testovací odběratel'), column: 'rs.tester'},
      ],
    };
  },
  created(ReportsOperatorService) {
    this.entityService = ReportsOperatorService;
    this.entityService.getReportOperatorFormData(this.$route.params.id_operator, this.$route.params.id_report)
        .then((data) => {
          this.filterData = data;
          this.formFields.id_operator = this.$route.params.id_operator ? this.$route.params.id_operator : null;
          this.formFields.id_report = this.$route.params.id_report ? this.$route.params.id_report : data["report_dates"][0]["id"];
          this.$refs.reportsoperatorlistfilterref.setDefault(this.formFields);
        }).catch((e) => {
      this.setErrorMessage(e['error_message'])
    })
  },

  computed: {
    showLink(){
        return this.$_readActionAllowedAllOrOwnAndGlobal;
    },
    multipleActionOptions() {
      return [
        {value: 'choose', text: this.$gettext('Vyberte akci')},

        {value: 'csv_operatorView', text: this.$gettext('Exportovat do CSV')},
        {value: 'xlsx_operatorView', text: this.$gettext('Exportovat do XLSX')},
        {value: 'ods_operatorView', text: this.$gettext('Exportovat do ODS')},

        {value: 'csv_operatorDetail', text: this.$gettext('Exportovat do CSV - detailní report')},
        {value: 'xlsx_operatorDetail', text: this.$gettext('Exportovat do XLSX - detailní report')},
        {value: 'ods_operatorDetail', text: this.$gettext('Exportovat do ODS - detailní report')},

        {value: 'csv_operatorPackage', text: this.$gettext('Exportovat do CSV - souhrn balíčků')},
        {value: 'xlsx_operatorPackage', text: this.$gettext('Exportovat do XLSX - souhrn balíčků')},
        {value: 'ods_operatorPackage', text: this.$gettext('Exportovat do ODS - souhrn balíčků')},

        {value: 'csv_operatorService', text: this.$gettext('Exportovat do CSV - služby')},
        {value: 'xlsx_operatorService', text: this.$gettext('Exportovat do XLSX - služby')},
        {value: 'ods_operatorService', text: this.$gettext('Exportovat do ODS - služby')},

        {value: 'csv_operatorVod', text: this.$gettext('Exportovat do CSV - videotéka')},
        {value: 'xlsx_operatorVod', text: this.$gettext('Exportovat do XLSX - videotéka')},
        {value: 'ods_operatorVod', text: this.$gettext('Exportovat do ODS - videotéka')},
      ]
    },
    operatorName() {
      if (this.filterData.hasOwnProperty("operator_data")) {
        return this.filterData.operator_data.name;
      }
      return this.$gettext("Detail reportu operátora");
    },
  },
  methods: {
    onFilterChange(filterData) {
      this.formFields = {...this.formFields, ...filterData};
    },
    runMultipleAction(action) {
      let typeList = ['operatorPackage', 'operatorDetail', 'operatorView', 'operatorService', 'operatorVod'];
      let actionData = action.split("_");
      let format = actionData[0];
      let type = actionData[1];
      if (typeList.includes(type)) {
        this.entityService.exportCsv({...this.formFields, ...{'id_subscribers': this.filteredSelectedEntities.join()}}, format, type)
            .then((response) => {
              this.setInfoMessageWithTimeout(this.$gettext('Stahování souboru...'))
              downloadTableFile(response, type, format)
            })
      }
    },

    _processGetEntitiesResponse(response) {
      response.then(data => {
        this.dataLoaded = true
        this.entities = data[this.moduleName]['subscribers'];
        this.channelPackages = data[this.moduleName]['channelPackages'];
        this.totalCount = Number(data['totalCount'])
        this.emptyMessage()
      })
          .catch(error => {
            this.setErrorMessage(this._processListErrorMessage(error))
          })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/reports/ReportsOperatorList.vue